module.exports = __webpack_public_path__ + "img/tareas.a3ca6af1.png";